import { Page } from '@/components/Page'
import { ADMIN } from '@/constants/links'

import { StrategyActionsProvider } from './StrategyActions'
import { StrategiesGrid } from './components/StrategiesGrid'

export const StrategiesPage = () => (
  <Page metadata={{ title: ADMIN.STRATEGY.label }} permissions={ADMIN.STRATEGY.permissions} layout="fill">
    <StrategyActionsProvider>
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <StrategiesGrid />
      </div>
    </StrategyActionsProvider>
  </Page>
)
